export default __webpack_public_path__ + "assets/f80fa8f9230d6b254a562b23134e90e0.png";